export const productConstants = {
  GETALL_REQUEST: 'PRODUCT_GETALL_REQUEST',
  GETALL_SUCCESS: 'PRODUCT_GETALL_SUCCESS',
  GETALL_FAILURE: 'PRODUCT_GETALL_FAILURE',
  GET_AVAILABLE_REQUEST: 'PRODUCT_GET_AVAILABLE_REQUEST',
  GET_AVAILABLE_SUCCESS: 'PRODUCT_GET_AVAILABLE_SUCCESS',
  GET_AVAILABLE_FAILURE: 'PRODUCT_GET_AVAILABLE_FAILURE',
};
